import { forwardRef, type ButtonHTMLAttributes } from "react";
import styles from "./button.module.scss";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost" | "destructive";
  size?: "sm" | "md" | "lg";
  loading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "primary", size = "md", loading, className, children, disabled, ...props }, ref) => {
    const cls = [
      styles.button,
      styles[variant],
      styles[size],
      loading ? styles.loading : "",
      className ?? "",
    ].filter(Boolean).join(" ");

    return (
      <button ref={ref} className={cls} disabled={disabled || loading} {...props}>
        {loading && <span className={styles.spinner} />}
        {children}
      </button>
    );
  },
);

Button.displayName = "Button";
